import { PhotosphereModel } from "./photosphere.model";

export class ShortcutModel {
    public uuid: string;
    public title: string;
    public description: string;
    public photosphere: PhotosphereModel;

    constructor(value: JSON) {
        this.uuid = value["uuid"];
        this.title = value["title"];
        this.description = value["description"];
        if(value["photosphere"]) {
            this.photosphere = new PhotosphereModel(value["photosphere"]);
        }
    }
}